export default [
  {
    name: 'Нет',
    key: 'no',
  },
  {
    name: 'Центральная',
    key: 'central',
  },
  {
    name: 'Септик',
    key: 'septicTank',
  },
  {
    name: 'Выгребная яма',
    key: 'cesspool',
  },
];
